function getDaysForMonthlyDisplay(year, month) {
  let currentDays = [];
  let allDays = [];
  // steps:
  // number of days in the month (it can be a subroutine)
  let firstDayOfCurrentMonth = new Date(year, month);
  let daysInMonth = getDaysInMonth(year, month);
  let lastDayOfCurrentMonth = new Date(year, month, daysInMonth);

  let dayOfTheWeek = firstDayOfCurrentMonth.getDay();

  let daysBeforeCount = calcBeforeDays(dayOfTheWeek);

  // let's push those days into our array ...
  let prevDays = getLastNDaysOfPreviousMonth(year, month, daysBeforeCount);

  // find out the day of last day
  dayOfTheWeek = lastDayOfCurrentMonth.getDay();
  let daysAfterCount = calcAfterDays(dayOfTheWeek);

  let afterDays = getFirstNDaysOfNextMonth(year, month, daysAfterCount);

  // finally, push days from this month
  for (let ix = 1; ix <= daysInMonth; ix++) {
    let day = new Date(year, month, ix);
    let dayInWeek = day.getDay();
    let weekOfTheYear = weekOfYear(year, month, ix);

    currentDays.push({
      year: year,
      month: month,
      day: ix,
      dayOfWeek: dayInWeek,
      weekOfTheYear: weekOfTheYear
    })
  }

  // now lets join the arrays...
  allDays = [...prevDays, ...currentDays, ...afterDays];
  return allDays;
}

function getDaysInMonth(year, month) {
  let day = new Date(year, month);

  let firstDayOfNextMonth = getFirstDayOfNextMonth(year, month);
  
  let difference = firstDayOfNextMonth - day;

  // important to use round instead of floor (not an integer result because of floating points)
  let daysFromMillis = Math.round(difference / (24 * 60 * 60 * 1000));

  return daysFromMillis;
}

function getFirstDayOfNextMonth(year, month) {
  if (month < 11) {
    return new Date(year, month + 1);
  } else {
    return new Date(year + 1, 0);
  }
}

function getLastNDaysOfPreviousMonth(year, month, n) {
  let prevDays = [];
  
  // first question: what is the previous month?
  month = month > 0 ? month - 1 : 11;
  year = month > 0 ? year : year - 1;

  let daysInPrevMonth = null;

  daysInPrevMonth = getDaysInMonth(year, month);

  for (let ix = 0; ix < n; ix++) {
    let day = new Date(year, month, daysInPrevMonth - ix);
    let dayInWeek = day.getDay();
    let weekOfTheYear = weekOfYear(year, month, daysInPrevMonth - ix);

    prevDays.unshift({
      year: year,
      month: month,
      day: daysInPrevMonth - ix,
      dayInWeek: dayInWeek,
      weekOfTheYear: weekOfTheYear
    })
  }

  return prevDays;
}

function getFirstNDaysOfNextMonth(year, month, n) {
  let afterDays = [];
  
  // first question: what is the previous month?
  month = month < 11 ? month + 1 : 0;
  year = month < 11 ? year : year + 1;

  for (let ix = 1; ix <= n; ix++) {
    let day = new Date(year, month, ix);
    let dayInWeek = day.getDay();
    let weekOfTheYear = weekOfYear(year, month, ix);

    afterDays.push({
      year: year,
      month: month,
      day: ix,
      dayInWeek: dayInWeek,
      weekOfTheYear: weekOfTheYear
    })
  }

  return afterDays;
}

function calcBeforeDays(day) {
  return (day + 6) % 7;
}

function calcAfterDays(day) {
  return (7 - day) % 7;
}

// TODO
// 1. dayOfTheWeek
// 2. weekOfTheYear

function isLeapYear(year) {
  if (year % 4 !== 0) {
    return false;
  } else if (year % 400 === 0) {
    return true;
  } else if (year % 100 === 0) {
    return false;
  } else {
    return true;
  }
}

function getDaysPerMonth(year) {

  let days = [31];

  if (isLeapYear(year)) {
    days.push(29);
  } else {
    days.push(28);
  }

  days = days.concat([31, 30, 31, 30, 31, 31, 30, 31, 30, 31])

  return days;
}

function dayOfYear(year, month, day) {
  let daysOfPastMonths = 
    getDaysPerMonth(year)
    .slice(0, month)
    .reduce((acc, el) => acc + el, 0);

  let daysTotal = daysOfPastMonths + day;
  return daysTotal;
}

function weekOfYear(year, month, day) {
  // see if first day is monday..
  let firstDayOfYear = new Date(year, 0);
  let offset = calcBeforeDays(firstDayOfYear.getDay());

  let dayOfTheYear = dayOfYear(year, month, day);
  let theWeek = Math.floor((offset + dayOfTheYear) / 7) + 1;

  return theWeek;
}

export default getDaysForMonthlyDisplay